/* eslint-disable import/prefer-default-export */
export const editCriteriaFormValuesSelector = (state) =>
  state.forms.criteria.edit
